import { render, staticRenderFns } from "./CommonDialog.vue?vue&type=template&id=4a23b99e"
import script from "./CommonDialog.vue?vue&type=script&lang=js"
export * from "./CommonDialog.vue?vue&type=script&lang=js"
import style0 from "./CommonDialog.vue?vue&type=style&index=0&id=4a23b99e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports